import type {Component} from 'grapesjs';
import {ICON_VECTOR_BG_FILL_PROP, ICON_VECTOR_TICK_FILL_PROP} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';

const ICON_VECTOR_BG_CLASS = 'js-icon-vector-background';
const ICON_VECTOR_TICK_CLASS = 'js-icon-vector-tick';

export function syncIconVectorContent(iconVector: Component): void {
  const content = iconVector.get('content');
  if (typeof content !== 'string' || content === '') {
    return;
  }
  const style = iconVector.getStyle() as Record<string, string | undefined>;
  const bgFill = style[ICON_VECTOR_BG_FILL_PROP] ?? '';
  const tickFill = style[ICON_VECTOR_TICK_FILL_PROP] ?? '';
  const doc = new DOMParser().parseFromString(content, 'image/svg+xml');
  if (doc.querySelector('parsererror')) {
    return;
  }
  const root = doc.documentElement;
  applyFillToAll(root, ICON_VECTOR_BG_CLASS, bgFill);
  applyFillToAll(root, ICON_VECTOR_TICK_CLASS, tickFill);
  const next = new XMLSerializer().serializeToString(root);
  if (next === content) {
    return;
  }
  iconVector.set('content', next);
}

function applyFillToAll(root: Element, className: string, fill: string): void {
  root.querySelectorAll(`.${className}`).forEach((el: Element): void => {
    const svgEl = el as SVGElement;
    if (fill === '') {
      svgEl.style.removeProperty('fill');
      return;
    }
    svgEl.style.setProperty('fill', fill);
  });
}
